import React from "react";
import { useNavigate } from "react-router-dom";
import { X, Bell, ChevronLeft } from "lucide-react";
import { useT } from "@/lib/i18n";
import { NOTIF_MODULES } from "@/lib/notifModules";

export default function NotifSummaryPanel({ open, onClose, summary }) {
  const { t } = useT();
  const navigate = useNavigate();
  if (!open) return null;
  const s = summary || {};

  return (
    <>
      <div className="fixed inset-0 bg-black/50 z-40 animate-fade-in" onClick={onClose} data-testid="notif-summary-backdrop" />
      <aside
        className="fixed top-0 bottom-0 z-50 w-96 max-w-[92vw] bg-white shadow-2xl flex flex-col animate-slide-in"
        style={{ insetInlineEnd: 0 }}
        data-testid="notif-summary-panel"
      >
        <div className="brand-gradient text-white px-5 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Bell size={18} />
            <div className="leading-tight">
              <div className="font-bold text-sm">{t("notif_center_title")}</div>
              <div className="text-[11px] text-teal-100">{t("notif_center_subtitle")}</div>
            </div>
          </div>
          <button onClick={onClose} className="text-white/80 hover:text-white p-1" data-testid="notif-summary-close">
            <X size={18} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {(s.total || 0) === 0 && (
            <div className="text-center text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-xl py-3 px-4 font-semibold" data-testid="notif-summary-all-read">
              {t("notif_all_read")}
            </div>
          )}
          {NOTIF_MODULES.map((m) => {
            const count = s[m.key] || 0;
            return (
              <button
                key={m.key}
                onClick={() => { onClose(); navigate(`/alerts/${m.key}`); }}
                className="w-full text-start rounded-2xl border-2 border-slate-100 hover:border-teal-300 bg-white shadow-sm hover:shadow-md transition p-4 flex items-center gap-3"
                data-testid={`notif-summary-${m.key}`}
              >
                <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${m.grad} text-white flex items-center justify-center shrink-0`}>
                  <m.icon size={20} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-sm text-slate-800 truncate">{t(m.titleKey)}</div>
                  <div className="text-[11px] text-slate-400 truncate">{t(m.descKey)}</div>
                </div>
                {count > 0 && (
                  <span
                    className="min-w-[26px] px-2 py-1 rounded-full bg-rose-500 text-white text-[11px] font-black text-center"
                    data-testid={`notif-summary-count-${m.key}`}
                  >
                    {count > 99 ? "99+" : count}
                  </span>
                )}
                <ChevronLeft size={16} className="text-slate-300 rtl:rotate-0 ltr:rotate-180" />
              </button>
            );
          })}
        </div>
      </aside>
    </>
  );
}
